import type { JSX } from 'react'
import { PageLayout } from '#src/components/display/PageLayout.tsx'
import { SDRTable } from '#src/components/sdr/display/SDRTable.tsx'

export const SDRsPage = (): JSX.Element => (
  <PageLayout title="Service Determination Requests">
    <SDRTable />
  </PageLayout>
)
